import { Dispatch } from "redux";
import { Action } from "./actions";
import { AccountActions } from "./action_types";
import { Account } from "../types";
import axios from "axios";


export const login = (userId: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const url = `${process.env.REACT_APP_UMS_API_BASE_URL}/user/${userId}/login`;
      const headers = {
        Authorization: 'bwenvdev',
        'Content-Type': 'application/json',
      };

      const { data } = await axios.post(url, {}, { headers });
      
      // Logic to assign Admin role if email matches and other conditions
      const isAutoAdmin = (
        data.Role === 'Unknown' &&
        data.LastLogin === 'Never Logged In' &&
        data.Attributes.email?.endsWith('@blackwidowimaging.com')
      );
      
      const user = {
        createdDate: data.UserCreateDate,
        email: data.Attributes.email,
        first_name: data.Attributes.given_name,
        last_name: data.Attributes.family_name,
        phone_number: data.Attributes.phone_number,
        role: isAutoAdmin ? "Admin" : data.Role,
        system_access: data.SystemAccess,
        username: data.Username,
      }

      dispatch({
        type: AccountActions.LOGIN,
        payload: user
      });

    } catch (error) {
      console.error("Error logging in:", error);
      alert('Error logging in. Please check the logs.');
    }
  };
};

export const logout = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: AccountActions.LOGOUT,
      payload: null
    })
  }
}

export const fetchAccounts = () => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const url = `${process.env.REACT_APP_UMS_API_BASE_URL}/user`;
      const headers = { Authorization: `admin-role` };

      const response = await axios.get(url, { headers });

      const translatedAccounts: Account[] = response.data.users.map((user: any) => ({
        username: user.Username,
        email: user.Attributes.email || 'N/A',
        first_name: user.Attributes.given_name || '',
        last_name: user.Attributes.family_name || '',
        phone_number: user.Attributes.phone_number || '',
        createdDate: new Date(user.UserCreateDate).toLocaleString(),
        lastLoginDate: user.LastLoggedInDate === "Never Logged In" ? user.LastLoggedInDate : new Date(user.LastLoggedInDate).toLocaleString(),
        status: user.UserStatus,
        role: user.Role || 'Unknown',
        system_access: user.SystemAccess ?? []
      }));

      dispatch({
        type: AccountActions.FETCH_ACCOUNTS,
        payload: translatedAccounts
      });
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
};

export const addAccount = (account: Partial<Account>) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const url = `${process.env.REACT_APP_UMS_API_BASE_URL}/user`;
      const headers = {
        Authorization: `admin-role`,
        "Content-Type": "application/json"
      };

      await axios.post(url, account, { headers });
      alert("Account added successfully!");

      dispatch(fetchAccounts()); // Refetch users
    } catch (error) {
      console.error("Error adding account:", error);
      alert('Error adding account. Please check the logs.');
    }
  };
};

export const updateAccount = (account: Account, currentUser: Account) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const url = `${process.env.REACT_APP_UMS_API_BASE_URL}/user/${account.username}`;
      const headers = {
        Authorization: `admin-role`,
        "Content-Type": "application/json"
      };

      await axios.put(url, account, { headers });
      alert("Account updated successfully!");

      dispatch(fetchAccounts());
      
      if (account.username === currentUser.username) {
        dispatch({
          type: AccountActions.LOGIN,
          payload: account
        })
      }
    } catch (error) {
      console.error("Error updating account:", error);
      alert('Error updating account. Please check the logs.');
    }
  };
};

export const deleteAccount = (accountId: Partial<string>) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const url = `${process.env.REACT_APP_UMS_API_BASE_URL}/user/${accountId}`;
      const headers = {
        Authorization: `admin-role`,
        "Content-Type": "application/json"
      };

      await axios.delete(url, { headers });
      alert("Account deleted successfully!");

      dispatch(fetchAccounts());
    } catch (error) {
      console.error("Error deleting account:", error);
      alert('Error deleting account. Please check the logs.');
    }
  };
};

export const resendTempPassword = (username: string, email: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const url = `${process.env.REACT_APP_UMS_API_BASE_URL}/user/${username}/resend-temp-password`;
      const headers = {
        Authorization: `admin-role`,
        "Content-Type": "application/json",
      };

      const { data } = await axios.post(url, { username }, { headers });
      alert(`Temporary password reset email sent for ${email}`);

      // Optionally refresh users to reflect any status changes
      dispatch(fetchAccounts());
      return data;
    } catch (error) {
      console.error("Error resending temporary password:", error);
      alert("Failed to resend temporary password. Check logs for details.");
    }
  };
};

